<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:22
 * @LastEditors: yd
 * @LastEditTime: 2020-08-12 14:21:12
-->
<template>
  <div>
    <group></group>
  </div>
</template>

<script>
import group from './modules/group'
export default {
  components: {
    group
  },
  props: {},
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
